import { Scope } from '@unform/core';
import React from 'react';
import { FaCheckCircle, FaFilePdf, FaRegFileVideo } from 'react-icons/fa';
import { Input } from '../../';
import { IndicadorDocumento } from '../../../IndicadorDocumento';
import './Preview.css';

const Preview = ({ onRemove = () => {}, arquivo, modoLeitura = false, index = 0 }) => {
    const [chave, extensao] = Array.from(arquivo.key ? arquivo.key.split('.') : []);

    const getExt = nome => nome.substring(nome.lastIndexOf('.'));
    const ehPDF = nome => getExt(nome) === '.pdf';
    const ehVideo = nome => ['.avi', '.mp4', '.mov', '.3gp', '.wmv'].includes(getExt(nome));

    const previewSemThumb = arquivo?.preview.replace('thumb-', '');

    if (modoLeitura) {
        return (
            <div className="mr-2 mb-2" style={{ position: 'relative', width: 100, height: 120 }}>
                <a target="_blank" href={previewSemThumb} rel="noopener noreferrer">
                    <IndicadorDocumento>{index + 1}</IndicadorDocumento>
                    {ehPDF(arquivo?.preview) ? (
                        <FaFilePdf className="img-thumbnail rounded" style={{ width: '100%', height: '100%', objectFit: 'cover' }} color="#CC2F2A" />
                    ) : ehVideo(arquivo?.preview) ? (
                        <FaRegFileVideo className="img-thumbnail rounded" style={{ width: '100%', height: '100%', objectFit: 'cover' }} color="#CC2F2A" />
                    ) : (
                        <img className="img-thumbnail rounded" style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={arquivo.preview} alt="Arquivo" />
                    )}
                </a>
            </div>
        );
    }

    return (
        <div>
            {!arquivo.error && !arquivo.uploaded && <div className="loader"></div>}
            {!arquivo.error && arquivo.uploaded && (
                <>
                    <Scope path={`keys[${index}]`}>
                        <Input type="hidden" name="chave" defaultValue={chave} />
                        <Input type="hidden" name="extensao" defaultValue={extensao} />
                    </Scope>

                    <div className="mr-2 mb-2">
                        <div className="mb-2" style={{ position: 'relative', width: 100, height: 120 }}>
                            {ehPDF(arquivo.key) ? (
                                <FaFilePdf className="img-thumbnail rounded" style={{ width: '100%', height: '100%', filter: 'brightness(70%)', objectFit: 'cover' }} color="#CC2F2A" />
                            ) : ehVideo(arquivo.key) ? (
                                <FaRegFileVideo className="img-thumbnail rounded" style={{ width: '100%', height: '100%', filter: 'brightness(70%)', objectFit: 'cover' }} color="#CC2F2A" />
                            ) : (
                                <img className="img-thumbnail rounded" style={{ width: '100%', height: '100%', filter: 'brightness(70%)', objectFit: 'cover' }} src={arquivo.preview} alt="Arquivo" />
                            )}

                            <FaCheckCircle size={20} color="#fff" style={{ position: 'absolute', right: 5, bottom: 5 }} />
                        </div>

                        <button
                            type="button"
                            style={{ width: '100%' }}
                            className="btn btn-secondary"
                            onClick={e => {
                                e.preventDefault();
                                onRemove(arquivo);
                            }}
                        >
                            Remover
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default Preview;
